import { Component } from '@angular/core';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'pap-microsite';
  currentURL = document.location.pathname;

  constructor() {
    console.log(document.location.pathname)
    this.currentURL = document.location.pathname;
  }



}
